'use client';

import { GoogleMap, type GoogleMapProps } from '@vs-shop/ui/googleMap';

/** Public tenant configuration controls the shared map. */
export default function ContentBlockGoogleMap({
  latitude,
  longitude,
  zoom,
}: Pick<GoogleMapProps, 'latitude' | 'longitude' | 'zoom'>) {
  return (
    <div className="flex aspect-[16/9] flex-1 overflow-hidden rounded-xl">
      <GoogleMap
        apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY ?? ''}
        mapId={process.env.NEXT_PUBLIC_GOOGLE_MAPS_MAP_ID ?? ''}
        latitude={latitude}
        longitude={longitude}
        zoom={zoom}
      />
    </div>
  );
}
